import React, { useEffect } from 'react';
import { getRawDomainFromSearch, getRawDomain } from "./Theme";
import LoaderPR from "./LoaderPR";
import { serviceUrl } from "./SSOService";
import * as Utils from "./Utils";
import { Form, HeaderForm, ContentForm, DescriptionForm } from "./Form";

function NoMatch() {
    useEffect(() => {
        let domain = getRawDomainFromSearch();
        let rawDomain = getRawDomain();
        let returnUrl = `${serviceUrl}/checklogin`;
        if(domain && domain !== ""){
            returnUrl = `${returnUrl}?returnUrl=https://${domain}`;
        }else if(rawDomain && rawDomain !==""){
            returnUrl = `${returnUrl}?returnUrl=https://${rawDomain}`;
        }
        Utils.redirectPage(returnUrl);
    }, [])

    return (
        <Form name="loginForm">
          <HeaderForm />
          <ContentForm>
            <DescriptionForm
             title="Login"
             description="Redirecting to HealthNexus SSO"
            />
            <LoaderPR showLoading={true} />
          </ContentForm>
        </Form>
    );

}

export default NoMatch;